import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["button", "input"]

  connect() {
    const isEnabled = this.inputTarget.value === "true"
    this.buttonTarget.classList.toggle("active", isEnabled)
  }

  toggle() {
    console.log("Toggling thinking input")
    const isEnabled = this.inputTarget.value === "true"
    this.inputTarget.value = (!isEnabled).toString()

    // Manually dispatch change event for listeners
    this.inputTarget.dispatchEvent(new Event("change"))

    this.buttonTarget.classList.toggle("active", !isEnabled)
  }
}
